import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classNames from "classnames";
import { Elements, RichText } from "prismic-reactjs";
import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { ProductReviewsPopup } from "./ProductDetailsPopup";
export function SliceProductDetailsAccordion(_ref) {
  var _item$rich_text_, _item$rich_text_2;

  var item = _ref.item;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState("0px"),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      activeGallery = _useState6[0],
      setActiveGallery = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      activeGalleryIndex = _useState8[0],
      setActiveGalleryIndex = _useState8[1];

  var content = useRef(null);
  var slider = useRef(null);
  var sliderSettings = {
    // adaptiveHeight: true,
    arrows: true,
    infinite: false,
    responsive: [{
      breakpoint: 767,
      settings: {
        // variableWidth: false,
        // adaptiveHeight: true,
        swipe: false
      }
    }],
    slidesToScroll: 1,
    slidesToShow: 1 // variableWidth: true,

  };

  function toggleAccordion() {
    setActive(!active);

    if (content.current) {
      setHeight(active ? "0px" : "".concat(content.current.scrollHeight, "px"));
    }
  }

  function showGallery(gallery, index) {
    setActiveGallery(gallery);
    setActiveGalleryIndex(index);
    document.body.classList.add("hidden");
  }

  function _closeGallery() {
    setActiveGallery([]);
    document.body.classList.remove("hidden");
  }

  var propsWithUniqueKey = function propsWithUniqueKey(props, key) {
    return _objectSpread({}, props || {}, key);
  };

  var htmlSerializer = function htmlSerializer(type, element, contentHtml, childrenHtml, key) {
    var props = {};

    switch (type) {
      // Don't wrap images in a <p> tag
      case Elements.image:
        props = {
          alt: element.alt || "Img",
          onClick: function onClick() {
            showGallery([_objectSpread({}, element)], 0);
          },
          src: element.url
        };
        return React.createElement("p", {
          className: "block-img"
        }, React.createElement("img", propsWithUniqueKey(props, key)));

      default:
        return null;
    }
  };

  var showPopup = activeGallery && !!activeGallery.length;
  var hasRichTextContent = (item === null || item === void 0 ? void 0 : (_item$rich_text_ = item.rich_text_2) === null || _item$rich_text_ === void 0 ? void 0 : _item$rich_text_.some(function (z) {
    return z.type === "image" ? Boolean(z.url) : false;
  })) || false;
  var imagesByRichText = item === null || item === void 0 ? void 0 : (_item$rich_text_2 = item.rich_text_2) === null || _item$rich_text_2 === void 0 ? void 0 : _item$rich_text_2.filter(function (z) {
    return z.type === "image";
  });
  return React.createElement(React.Fragment, null, showPopup && React.createElement(ProductReviewsPopup, {
    gallery: activeGallery,
    galleryIndex: activeGalleryIndex,
    closeGallery: function closeGallery() {
      _closeGallery();
    }
  }), React.createElement("button", {
    type: "button",
    className: classNames("slice-product-details__list-button", {
      active: active
    }),
    onClick: toggleAccordion
  }, item.title && React.createElement(RichText, {
    render: item.title
  })), React.createElement("div", {
    className: "slice-product-details__list-content",
    ref: content,
    style: {
      maxHeight: "".concat(height)
    }
  }, React.createElement("div", {
    className: "list-content"
  }, item.subtitle && React.createElement(RichText, {
    render: item.subtitle
  }), React.createElement("div", {
    className: "list-content-container"
  }, item.rich_text && React.createElement("div", {
    className: classNames("list-content-col list-content-col--left", {
      "col-full-width": !hasRichTextContent
    })
  }, React.createElement(RichText, {
    render: item.rich_text,
    htmlSerializer: htmlSerializer
  })), hasRichTextContent && React.createElement("div", {
    className: "list-content-col list-content-col--right"
  }, React.createElement(Slider, _extends({}, sliderSettings, {
    ref: slider
  }), imagesByRichText.map(function (slide, slideIndex) {
    return React.createElement("button", {
      type: "button",
      className: "content__slide",
      key: "imgSlide-".concat(slideIndex),
      onClick: function onClick() {
        return showGallery(imagesByRichText, slideIndex);
      }
    }, React.createElement("img", {
      src: slide.url,
      alt: "Img"
    }));
  })))))));
}
SliceProductDetailsAccordion.componentName = "product_details_accordion";